import { CreateReasonUseCase } from '@/data/use-cases/misc-use-cases.js';
import { GetUnreadCountUseCase } from '@/data/use-cases/misc-use-cases.js';
import { LoadDashboardUseCase } from '@/data/use-cases/misc-use-cases.js';
import { LoadNotificationsUseCase } from '@/data/use-cases/misc-use-cases.js';
import { LoadReasonsUseCase } from '@/data/use-cases/misc-use-cases.js';
import { MarkAllNotificationsReadUseCase } from '@/data/use-cases/misc-use-cases.js';
import { MarkNotificationReadUseCase } from '@/data/use-cases/misc-use-cases.js';
import { ToggleReasonUseCase } from '@/data/use-cases/misc-use-cases.js';
import { UpdateReasonUseCase } from '@/data/use-cases/misc-use-cases.js';
import type { FetchHttpClient } from '@/infra/http/fetch-http-client.js';
import { DashboardRepositoryImpl } from '@/infra/repositories/dashboard-repository-impl.js';
import { NotificationRepositoryImpl } from '@/infra/repositories/notification-repository-impl.js';
import { ReasonRepositoryImpl } from '@/infra/repositories/reason-repository-impl.js';
import { DashboardController } from '@/presentation/controllers/dashboard-controller.js';
import { NotificationController } from '@/presentation/controllers/notification-controller.js';
import { ReasonController } from '@/presentation/controllers/reason-controller.js';

export const makeDashboardController = (httpClient: FetchHttpClient): DashboardController => {
    const repository = new DashboardRepositoryImpl(httpClient);
    return new DashboardController(new LoadDashboardUseCase(repository));
};

export const makeNotificationController = (httpClient: FetchHttpClient): NotificationController => {
    const repository = new NotificationRepositoryImpl(httpClient);
    return new NotificationController(
        new LoadNotificationsUseCase(repository),
        new MarkNotificationReadUseCase(repository),
        new MarkAllNotificationsReadUseCase(repository),
        new GetUnreadCountUseCase(repository)
    );
};

export const makeReasonController = (httpClient: FetchHttpClient): ReasonController => {
    const repository = new ReasonRepositoryImpl(httpClient);
    return new ReasonController(new LoadReasonsUseCase(repository), new CreateReasonUseCase(repository), new UpdateReasonUseCase(repository), new ToggleReasonUseCase(repository));
};
